function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Ellipses"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 8,
  transform: "translate(0 12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8h-7c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5h7c.276 0 .5.224.5.5v7c0 .276-.224.5-.5.5z",
  className: "iconic-ellipses-dot iconic-ellipses-dot-1 iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5 8h-7c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5h7c.276 0 .5.224.5.5v7c0 .276-.224.5-.5.5z",
  className: "iconic-ellipses-dot iconic-ellipses-dot-2 iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.5 8h-7c-.276 0-.5-.224-.5-.5v-7c0-.276.224-.5.5-.5h7c.276 0 .5.224.5.5v7c0 .276-.224.5-.5.5z",
  className: "iconic-ellipses-dot iconic-ellipses-dot-3 iconic-property-fill"
}));

function SvgEllipsesMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "ellipses",
    className: "iconic iconic-ellipses iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesMd);
export default __webpack_public_path__ + "static/media/ellipses-md.a5005efc.svg";
export { ForwardRef as ReactComponent };